export const SITE_URL = "https://minocesari.com";
export const EMAIL = "info@minocesari.com";
export const PHONE = "+393356349006";
export const PHONE_DISPLAY = "+39 335 634 9006";
export const NAME = "Mino Cesari";
export const ROLE = "Mental Coach · Trainer · Networker";
export const PAYOFF = "From Potential to Performance";
export const QUOTE = "I risultati migliorano quando migliorano le persone.";
export const PORTRAIT_URL = "https://minocesari.com/assets/mino-vest.jpg";
export const LOGO_URL = "https://minocesari.com/assets/logo-mc-payoff.png";
export const MC_MARK_URL = "/assets/mc-mark.png";
